const _ = require('underscore');
const SingleAssetMap = require('./single_asset_map');
const AssetSearch = require('../project_map/asset_search');
const Geocoder = require('../common/geocoder');
const AssetForm = require('./edit_asset_form');

class EditAssetController {
  constructor(
    assetId,
    markerColor,
    $mapElement,
    $latInput,
    $lngInput,
    $addressInput,
    $addressButton,
    assetSearchUrl,
    options,
  ) {
    if (options == null) {
      options = {};
    }
    const self = this;

    this.newAsset = assetId === '';
    this.counter = $('#asset-count');
    this.$latInput = $latInput;
    this.$lngInput = $lngInput;
    this.$addressInput = $addressInput;
    this.assetSearch = new AssetSearch(
      $('#status-message'),
      assetSearchUrl,
      (assets, data_summary, user_locations) =>
        self.addAssets(assets, data_summary, user_locations),
    );
    const $addressSearchInput = $('#address-search-input');
    const $addressSearchSubmit = $('#address-search-submit');

    this.map = new SingleAssetMap(
      assetId,
      markerColor,
      $mapElement,
      this.getLatitude(),
      this.getLongitude(),
      _.bind(this.boundsChangedCallback, this),
      options,
    );

    new Geocoder(
      $addressSearchInput,
      $addressSearchSubmit,
      _.bind(this.map.centerMapOnPosition, this.map),
    );
    this.geocoder = new google.maps.Geocoder();
    this.setMapCenterFromLocation();
    this.setAddressButtonClick($addressButton);
    this.map.addPinCrosshair();

    new AssetForm();
  }

  getLatitude() {
    return this.floatFromString(this.$latInput.val());
  }

  getLongitude() {
    return this.floatFromString(this.$lngInput.val());
  }

  setMapCenterFromLocation() {
    const lat = this.getLatitude();
    const lng = this.getLongitude();

    if (lat && lng) {
      return this.map.setMapPosition(lat, lng);
    } else {
      const self = this;
      return this.getCurrentLocation(
        function (position) {
          self.map.setMapPosition(
            position.coords.latitude,
            position.coords.longitude,
          );
          return self.map.setCenterLocation(
            position.coords.latitude,
            position.coords.longitude,
          );
        },
        (err) =>
          console.warn('Geolocation error (' + err.code + '): ' + err.message),
      );
    }
  }

  getCurrentLocation(successCallback, errorCallback) {
    if (navigator.geolocation) {
      return navigator.geolocation.getCurrentPosition(
        successCallback,
        errorCallback,
      );
    } else {
      return errorCallback();
    }
  }

  boundsChangedCallback(newBounds) {
    return this.assetSearch.getAssetsByPositionBounds(newBounds);
  }

  addAssets(newAssets, assetsSummary, userLocations) {
    this.map.clearAllMarkers();

    if (this.newAsset) {
      this.counter.text(newAssets.length);
      this.map.setMarkersFromAssets(newAssets);
    }

    return this.map.setMarkersForUsers(userLocations);
  }

  setAddressButtonClick($addressButton) {
    return $addressButton.click(() => {
      const [lat, lng] = Array.from(this.map.getCenter());
      this.$latInput.val(lat).trigger('change');
      this.$lngInput.val(lng).trigger('change');
      return this.reverseGeocode(lat, lng, true);
    });
  }

  floatFromString(input) {
    let result = null;
    if (input) {
      const parsed = parseFloat(input);
      if (!isNaN(parsed)) {
        result = parsed;
      }
    }
    return result;
  }

  reverseGeocode(lat, lng, force) {
    if (force == null) {
      force = false;
    }
    if (!this.$addressInput.val() || force !== false) {
      const latlng = { location: { lat, lng } };
      return this.geocoder.geocode(latlng, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            return this.$addressInput.val(results[0].formatted_address);
          } else {
            return console.log('No reverse geocode results found');
          }
        } else {
          return console.log('Reverse geocoder failed due to: ' + status);
        }
      });
    }
  }
}

//-----------  EXPORT  -----------#
module.exports = EditAssetController;
window.EditAssetController = EditAssetController;
